import React from "react";
import { ClipLoader } from "react-spinners";
import { Container, Col, Row } from "reactstrap";
import Logo from "../assets/img/brand/new-logo.png";

const containerStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100vh",
};

class Loading extends React.Component {
  render() {
    const color = this.props.color || this.props.loaderColor || "#123abc";
    return (
      <div style={containerStyle}>
        <Container>
          <Row className="justify-content-center align-items-center">
            <Col xs="12" className="text-center">
              <img
                style={{ padding: 50, maxHeight: 350 }}
                src={Logo}
                alt="logo"
                className="logo"
              />
            </Col>
            <Col xs="12" className="text-center">
              <div style={{ display: "block", margin: "0 auto" }}>
                <ClipLoader size={60} color={color} />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default Loading;
